import React, { useState } from "react";
import { Wrapper, Button } from "../../components";
import { Link } from "react-router-dom";

// KYC Kampanyası için bir önizleme kartı
const CampaignCard = ({ title, description, image, startDate,endDate, link, isActive }) => {
  return (
    <div className="bg-dark-backgroundOnDark rounded-xl overflow-hidden border border-dark-line hover:border-primary/30 transition-all duration-300 hover:shadow-lg hover:shadow-primary/5 group">
      <div className="relative">
        {/* Kampanya görseli */}
        <div className="h-48 bg-dark-background/50 overflow-hidden">
          {image ? (
            <img 
              src={image} 
              alt={title} 
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-16 h-16 text-primary/40">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 11.25v8.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 109.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1114.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
              </svg>
            </div>
          )}
        </div>
        
        {/* Durum etiketi */}
        {isActive ? (
          <div className="absolute top-3 right-3 bg-primary text-white text-xs font-bold py-1 px-3 rounded-full">
            Aktif
          </div>
        ) : (
          <div className="absolute top-3 right-3 bg-dark-background/80 text-white text-xs font-bold py-1 px-3 rounded-full">
            Yakında
          </div>
        )}
      </div>
      
      <div className="p-5">
        <h3 className="text-white text-xl font-bold mb-2">{title}</h3>
        <p className="text-secondaryTwo text-sm mb-4 line-clamp-2">{description}</p>
        
        {startDate && (
          <div className="flex items-center text-xs text-secondaryTwo mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 mr-1 text-primary">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 9v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
            </svg>
            <span>Başlangıç: {startDate}</span>
          </div>
        )}

        {endDate && (
          <div className="flex items-center text-xs text-secondaryTwo mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 mr-1 text-primary">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 9v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
            </svg>
            <span>Bitiş: {endDate}</span>
          </div>
        )}

        
        <Link to={link} className="block">
          <Button 
            variant="primary" 
            className="w-full py-2 text-sm py-3 px-8 text-lg bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary shadow-lg shadow-primary/30 border-none"
          >
            Kampanyaya Katıl
          </Button>
        </Link>
      </div>
    </div>
  );
};

const KampanyaMerkezi = () => {
  const [activeTab, setActiveTab] = useState("active");
  
  // Aktif kampanyalar
  const activeCampaigns = [
    {
        id: 1,
        title: "KYC Tamamla, 100 TL Kazan",
        description: "GMSKripto'da KYC doğrulama sürecini tamamla, 100 TL ödül kazan ve ilk ay tüm işlemlerini %0 komisyon ile gerçekleştir!",
        image: null, // Burada bir görsel URL'si eklenebilir
        startDate: "15 Mayıs 2025",
        endDate: "30 Haziran 2025",
        link: "/kampanya-merkezi/kyc-kampanyasi",
        isActive: false
      },
  ];
  
  // Yakında gelecek kampanyalar
  const upcomingCampaigns = [
      {
      id: 3,
      title: "Trading Yarışması",
      description: "Trading yarışmalarına katıl, büyük ödüller kazan!",
      image: null,
      startDate: null,
      endDate: null,
      link: "#",
      isActive: false
    }
  ];

  return (
    <div className="bg-dark-background min-h-screen pb-20">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-b from-primary/10 to-dark-background pt-8 pb-16">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
          <div className="absolute top-10 left-1/4 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-1/4 w-64 h-64 bg-primary/10 rounded-full blur-3xl"></div>
        </div>
        
        <Wrapper>
          <div className="relative z-10">
            <div className="inline-flex items-center bg-dark-backgroundOnDark/80 backdrop-blur-sm rounded-full py-1.5 px-4 mb-4 border border-primary/30">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse mr-2"></span>
              <span className="text-primary text-sm font-medium">Özel Kampanyalar</span>
            </div>
            
            <h1 className="text-white text-3xl md:text-5xl font-bold mb-4">
              Kampanya Merkezi
            </h1>
            
            <p className="text-secondaryTwo text-lg max-w-2xl">
              GMSKripto'nun özel kampanyalarına katılın ve avantajlı fırsatlardan yararlanın. 
              Bonus kazanın, komisyon indirimleri yakalayın ve daha fazlasına sahip olun!
            </p>
          </div>
        </Wrapper>
      </div>
      
      {/* Tabs */}
      <Wrapper>
        <div className="flex border-b border-dark-line mb-8">
          <button 
            className={`py-3 px-6 font-medium ${activeTab === "active" ? "text-primary border-b-2 border-primary" : "text-secondaryTwo hover:text-white"}`}
            onClick={() => setActiveTab("active")}
          >
            Aktif Kampanyalar
          </button>
          <button 
            className={`py-3 px-6 font-medium ${activeTab === "upcoming" ? "text-primary border-b-2 border-primary" : "text-secondaryTwo hover:text-white"}`}
            onClick={() => setActiveTab("upcoming")}
          >
            Yakında
          </button>
          <button 
            className={`py-3 px-6 font-medium ${activeTab === "completed" ? "text-primary border-b-2 border-primary" : "text-secondaryTwo hover:text-white"}`}
            onClick={() => setActiveTab("completed")}
          >
            Geçmiş Kampanyalar
          </button>
        </div>
        
        {/* Aktif Kampanyalar */}
        {activeTab === "active" && (
          <div>
            <h2 className="text-white text-2xl font-bold mb-6">Aktif Kampanyalar</h2>
            
            {activeCampaigns.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {activeCampaigns.map(campaign => (
                  <CampaignCard key={campaign.id} {...campaign} />
                ))}
              </div>
            ) : (
              <div className="bg-dark-backgroundOnDark/30 rounded-xl p-10 text-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-16 h-16 text-secondaryTwo/50 mx-auto mb-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                </svg>
                <h3 className="text-white text-xl font-bold mb-2">Şu anda aktif kampanya bulunmuyor</h3>
                <p className="text-secondaryTwo">Yeni kampanyalarımız için bizi takip etmeye devam edin!</p>
              </div>
            )}
          </div>
        )}
        
        {/* Yakında Gelecek Kampanyalar */}
        {activeTab === "upcoming" && (
          <div>
            <h2 className="text-white text-2xl font-bold mb-6">Yakında Gelecek Kampanyalar</h2>
            
            {upcomingCampaigns.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {upcomingCampaigns.map(campaign => (
                  <CampaignCard key={campaign.id} {...campaign} />
                ))}
              </div>
            ) : (
              <div className="bg-dark-backgroundOnDark/30 rounded-xl p-10 text-center">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-16 h-16 text-secondaryTwo/50 mx-auto mb-4">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                </svg>
                <h3 className="text-white text-xl font-bold mb-2">Yakında yeni kampanyalar geliyor</h3>
                <p className="text-secondaryTwo">Yeni kampanyalarımız için bizi takip etmeye devam edin!</p>
              </div>
            )}
          </div>
        )}
        
        {/* Geçmiş Kampanyalar */}
        {activeTab === "completed" && (
          <div>
            <h2 className="text-white text-2xl font-bold mb-6">Geçmiş Kampanyalar</h2>
            
            <div className="bg-dark-backgroundOnDark/30 rounded-xl p-10 text-center">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-16 h-16 text-secondaryTwo/50 mx-auto mb-4">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
              <h3 className="text-white text-xl font-bold mb-2">Geçmiş kampanya bulunmuyor</h3>
              <p className="text-secondaryTwo">Tamamlanan kampanyalarımız burada listelenecek.</p>
            </div>
          </div>
        )}
        
        {/* Kampanya Bilgilendirme Bölümü */}
        <div className="mt-16 bg-dark-backgroundOnDark/30 rounded-xl p-8 border border-dark-line">
          <h2 className="text-white text-2xl font-bold mb-4">Kampanyalar Hakkında</h2>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-white text-lg font-bold mb-2">Kampanyalara Nasıl Katılabilirim?</h3>
              <p className="text-secondaryTwo">
                GMSKripto kampanyalarına katılmak için öncelikle bir hesap oluşturmanız gerekir. 
                Hesabınızı oluşturduktan sonra, ilgilendiğiniz kampanyanın detay sayfasına giderek 
                katılım koşullarını inceleyebilir ve hemen katılabilirsiniz.
              </p>
            </div>
            
            <div>
              <h3 className="text-white text-lg font-bold mb-2">Kampanya Ödülleri</h3>
              <p className="text-secondaryTwo">
                Kampanyalarımız aracılığıyla nakit bonuslar, komisyon indirimleri, kripto para ödülleri ve 
                daha birçok avantaj kazanabilirsiniz. Her kampanyanın kendine özgü ödül yapısı vardır ve 
                detayları ilgili kampanya sayfasında bulabilirsiniz.
              </p>
            </div>
            
            <div>
              <h3 className="text-white text-lg font-bold mb-2">Kampanya Bildirimleri</h3>
              <p className="text-secondaryTwo">
                Yeni kampanyalardan haberdar olmak için GMSKripto hesabınızın bildirim ayarlarını 
                aktif tutabilir veya sosyal medya hesaplarımızı takip edebilirsiniz.
              </p>
            </div>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default KampanyaMerkezi; 